var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isNotGroup)?_c('span',[_c('v-icon',{staticStyle:{"font-size":"20px"},attrs:{"color":"primary"},on:{"click":function($event){return _vm.controlClick($event)}}},[_vm._v("mdi-delete-outline")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }